export const getters = {
  systemInterchanges: state => state.interchanges,
  Interchange: state => state.systemInterchange
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/getters.js